// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"0c3abcbc925f7dc78e53","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"9196fd6e1d6e09bda1b8","vendors-node_modules_rehype-highlight_index_js":"9a1aa4e77ec802149729"}[chunkId] + "";
};